<template>
  <section class="header">
    <section class="header__title">
      <h1>{{ $t("password.reset_password") }}</h1>

      <v-btn icon small @click="close">
        <v-icon small>mdi-close</v-icon>
      </v-btn>
    </section>

    <Steps />
  </section>
</template>

<script>
import Steps from "./Steps";
import { mapActions } from "vuex";

export default {
  name: "HeaderPasswordComponent",

  components: {
    Steps,
  },

  methods: {
    ...mapActions(["changeForDefaultPasswordConfig"]),

    close() {
      this.changeForDefaultPasswordConfig();
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  flex-direction: column;
  gap: 25px;

  .header__title {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    h1 {
      font-weight: 600;
      font-size: 20px;
      color: #000000;
      text-align: left;
    }
  }
}
</style>
